// Web shim for react-native-device-info
// Provides fallback implementations for common device info methods on web

const webShim = {
  getUniqueId: async (): Promise<string> => {
    return 'web-' + Math.random().toString(36).substr(2, 9);
  },
  getModel: async (): Promise<string> => {
    return 'Web Browser';
  },
  getSystemName: async (): Promise<string> => {
    return 'web';
  },
  getSystemVersion: async (): Promise<string> => {
    return typeof navigator !== 'undefined' && navigator.appVersion 
      ? navigator.appVersion.split(' ').pop() || '1.0'
      : '1.0';
  },
  getAppVersion: async (): Promise<string> => {
    return '1.0.0';
  },
  getBuildNumber: async (): Promise<string> => {
    return '1';
  },
  isTablet: async (): Promise<boolean> => {
    if (typeof window === 'undefined') return false;
    const ua = navigator.userAgent;
    return /ipad|android(?!.*mobi)/i.test(ua);
  },
  isLandscape: async (): Promise<boolean> => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth > window.innerHeight;
  },
  getDeviceId: async (): Promise<string> => {
    return 'web-device';
  },
};

export default webShim;
